import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RegistryRedirectComponent } from "./registry-redirect/registry-redirect.component";

@NgModule({
    imports: [CommonModule],
    declarations: [RegistryRedirectComponent],
})
export class SharedFeatureRedirectModule {}
